import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const BASE_KEY = "technology";
const DESCRIPTION_QUERY_KEY = "description";

export const technologyQueryKeys = {
    description: () => [BASE_KEY, DESCRIPTION_QUERY_KEY] as const,
} as const satisfies QueryKeyFactory;
